import { createSelector } from "reselect";
import { downloadReportdata } from "./model";

export const getIsDownloadDataFetched = (state, props) => state.reportsDownload.params.datafetched;
export const getSegmapList = (state, prop) => state.segmap.byId



export const getdownloadReportdata = (state, props) => {
    console.log("🚀 ~ getdownloadReportdata ~ props:", props)
    // if (props.match.path === '/download-reports') {
       
    // }
     return downloadReportdata()
}

export const selectLocation = (state, props) => {
    const location = state.segmap.byId
    const keys = Object.keys(location)
    const obj = keys.map((key) => {
        return { key: key, value: location[key].loc_cd, text: location[key].loc_cd }
    });
    return obj

}

export const selectOutlet = (state, props) => {
    const outlet = state.segmap.byId
    const keys = Object.keys(outlet)
    const obj = keys.map((key) => {
        return { key: key, value: outlet[key].outlet_cd, text: outlet[key].outlet_cd }
    });
    return obj

}